import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import '@mui/material/styles';


export const theme = createTheme({
    palette: {
        primary: {
            main: '#145DA0', // Custom primary color
        },
        secondary: {
            main: '#0C2D48', // Custom secondary color
        },
        yellow: {
          main: '#ffc60d'
        },
        champagne: {
          main: '#FDF2E7'
        },
        text: {
            primary: '#000000', // Custom text color
        },
        background: {
            default: '#f9f9f9', // Gradient for the default background
            paper: 'rgb(255,255,255)', // Semi-transparent white for card-like surfaces
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
      </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
